// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"319":"87b305cf","431":"0c0aecaf"}[chunkId] + ".chunk.css";
};